import { Lesson, Absence, Subject } from 'src/store/models/timetable/index.js'
import { LessonBookable, SubjectBookable } from 'src/store/models/pivot/index.js'
import CRUD from 'src/store/models/helper/CRUD.js'
import Timetable from 'src/api/timetable.js'

export class Bookable extends CRUD {
  static entity = 'bookables'
  static fetchUrl = Timetable.timetableBookablesUrl()

  static fields () {
    return {
      id: this.attr(null),
      school_id: this.attr(null),
      name: this.string(''),
      shortcut: this.string(''),
      subject_pivot: this.hasMany(SubjectBookable, 'bookable_id'),
      subjects: this.belongsToMany(Subject, SubjectBookable, 'bookable_id', 'subject_id'),
      description: this.attr(null),
      is_confirmable: this.boolean(false),
      is_custom: this.boolean(false),
      is_public: this.boolean(false),
      lessons: this.belongsToMany(Lesson, LessonBookable, 'bookable_id', 'lesson_id'),
      absences: this.morphMany(Absence, 'target_id', 'target_type'),
      meta: this.attr({ displayname: null })
    }
  }
}

export default Bookable
